export default {
	location: 'Location',
	'gps-data': 'GPS device data'
}